import {DealerEntityMixSpecification} from './dealer-mix-specification';

export class DealerEntityGroupMixRequest {
	dealerId: string;
	dealerType: string;
	volume: number;
	specifications: DealerEntityMixSpecification[];
}
